import * as Sentry from "@sentry/react";
import { useEffect } from "react";
import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from "react-router-dom";
// import { createBrowserRouter } from "react-router-dom";

/**
 * Инициализация Sentry с учетом окружения
 * Документация: https://docs.sentry.io/platforms/javascript/guides/react/
 */
// export const initSentry = () => {
// Определяем окружение из переменных Vite
const environment = import.meta.env.VITE_FRONT_ENVIRONMENT || "development";
const isDevelopment = environment === "development";

// Инициализируем Sentry только если есть DSN
const dsn = import.meta.env.VITE_SENTRY_DSN;
if (!dsn) {
  console.warn("Sentry DSN не найден. Sentry не будет инициализирован.");
  // return;
} else {
  Sentry.init({
    dsn,
    environment,
    // Включаем отладку в development
    debug: isDevelopment,

    // Настройки производительности
    tracesSampleRate: isDevelopment ? 1.0 : 0.2,
    profilesSampleRate: isDevelopment ? 1.0 : 0.2,

    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    sendDefaultPii: true,

    integrations: [
      Sentry.replayIntegration(),
      Sentry.browserTracingIntegration(),
      Sentry.browserProfilingIntegration(),
      Sentry.browserApiErrorsIntegration(),
      Sentry.breadcrumbsIntegration({
        console: true,
        dom: true,
        fetch: true,
        history: true,
        xhr: true,
      }),
      Sentry.reactRouterV6BrowserTracingIntegration({
        useEffect,
        useLocation,
        useNavigationType,
        createRoutesFromChildren,
        matchRoutes,
        traceFetch: true,
        traceXHR: true,
      }),
    ],

    // Фильтрация ошибок
    // beforeSend(event, hint) {
    //   // Не отправляем ошибки в development
    //   if (isDevelopment) {
    //     console.log("Sentry event (не отправлено в dev):", event);
    //     return null;
    //   }

    //   // Фильтруем известные ошибки браузера
    //   const error = hint.originalException;
    //   if (error instanceof Error) {
    //     // Игнорируем ошибки расширений браузера
    //     if (error.message.includes("Non-Error promise rejection captured")) {
    //       return null;
    //     }
    //     // Игнорируем ошибки сети
    //     if (error.message.includes("Network Error")) {
    //       return null;
    //     }
    //   }

    //   return event;
    // },

    // Настройки релиза
    release:
      import.meta.env.VITE_SENTRY_RELEASE ||
      `crm-frontend@${import.meta.env.VITE_APP_VERSION || "unknown"}`,

    // Дополнительные теги
    initialScope: {
      tags: {
        component: "frontend",
        stack: "react-vite",
      },
    },
  });
  // };

  // /**
  //  * Создание роутера с интеграцией Sentry
  //  */
  // export const createSentryRouter = (routes: any[]) => {
  //   return createBrowserRouter(routes);
  // };

  // /**
  //  * Обертка для компонентов с Error Boundary
  //  */
  // export const withSentryErrorBoundary = <P extends object>(
  //   Component: React.ComponentType<P>,
  //   options?: {
  //     fallback?: React.ComponentType<any>;
  //     beforeCapture?: (scope: Sentry.Scope) => void;
  //   }
  // ) => {
  //   return Sentry.withErrorBoundary(Component, {
  //     fallback: options?.fallback || ErrorFallback,
  //     beforeCapture: options?.beforeCapture,
  //   });
  // };

  // /**
  //  * Компонент-заглушка для ошибок
  //  */
  // const ErrorFallback: React.FC<{ error: Error; resetError: () => void }> = ({
  //   error,
  //   resetError,
  // }) => (
  //   <div className="flex min-h-screen items-center justify-center bg-background">
  //     <div className="text-center">
  //       <h1 className="text-2xl font-bold text-destructive mb-4">
  //         Что-то пошло не так
  //       </h1>
  //       <p className="text-muted-foreground mb-4">
  //         Произошла непредвиденная ошибка. Мы уже работаем над её исправлением.
  //       </p>
  //       <details className="mb-4 text-left">
  //         <summary className="cursor-pointer text-sm text-muted-foreground">
  //           Детали ошибки
  //         </summary>
  //         <pre className="mt-2 text-xs bg-muted p-2 rounded overflow-auto">
  //           {error.message}
  //         </pre>
  //       </details>
  //       <button
  //         onClick={resetError}
  //         className="bg-primary text-primary-foreground px-4 py-2 rounded hover:bg-primary/90"
  //       >
  //         Попробовать снова
  //       </button>
  //     </div>
  //   </div>
  // );
}
